var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArticleEditor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 340.52,
    rx: 234.01,
    ry: 138.85,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pictures--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--freepik--Pictures--inject-3--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--freepik--Picture--inject-3--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--freepik--Frame--inject-3--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "305.27 73.37 303.57 74.38 338.41 94.5 340.11 93.48 305.27 73.37",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.27 38.67 338.41 57.79 338.41 92.5 305.27 73.37 305.27 38.67",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.37,76.23,341.62,100V55.92L300.37,32.13Zm3.2-38.56,34.84,20.12V94.5L303.57,74.38Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.57 37.68 305.27 38.67 305.27 73.37 303.57 74.38 303.57 37.68",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.62 55.94 343.34 54.95 302.09 31.14 300.37 32.12 341.62 55.94",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343.34 99.06 341.62 100.05 341.62 55.94 343.34 54.95 343.34 99.06",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--freepik--Land--inject-3--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "306.56 63.51 315.88 52.75 326.43 75.31 324.72 67.92 329.48 63.51 337.12 81.15 337.12 89.97 306.56 72.33 306.56 63.51",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.75,56.32A5,5,0,0,0,325,60.23c1.26.69,2.26.14,2.26-1.31A5,5,0,0,0,325,55C323.76,54.27,322.75,54.85,322.75,56.32Z",
    style: {
      fill: "#ebebeb"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--freepik-picture-inject-3--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--freepik-frame-inject-3--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "305.27 139.34 303.57 140.35 338.41 160.47 340.11 159.45 305.27 139.34",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.27 104.64 338.41 123.76 338.41 158.47 305.27 139.34 305.27 104.64",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.37,142.2,341.62,166v-44.1L300.37,98.1Zm3.2-38.55,34.84,20.11v36.71l-34.84-20.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.57 103.65 305.27 104.64 305.27 139.34 303.57 140.35 303.57 103.65",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.62 121.91 343.34 120.92 302.09 97.11 300.37 98.1 341.62 121.91",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343.34 165.03 341.62 166.02 341.62 121.91 343.34 120.92 343.34 165.03",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--freepik-land-inject-3--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "306.56 129.48 315.88 118.72 326.43 141.28 324.72 133.89 329.48 129.48 337.12 147.12 337.12 155.94 306.56 138.3 306.56 129.48",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.75,122.31a5,5,0,0,0,2.26,3.91c1.26.7,2.26.14,2.26-1.3a5,5,0,0,0-2.28-4C323.76,120.24,322.75,120.83,322.75,122.31Z",
    style: {
      fill: "#ebebeb"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 400.34,
    cy: 353.78,
    rx: 45.96,
    ry: 24.97,
    style: {
      fill: "#dedede"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 310.12,
    cy: 429.16,
    rx: 46.07,
    ry: 25.03,
    style: {
      fill: "#dedede"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--freepik--shadow--inject-3--inject-2",
    d: "M231.41,377c48.11-25.28,93.73-48.35,132.82-71.75,6.76-4.94,6.25-12.52-1-16.7L217.29,196.13a29,29,0,0,0-26.25,0L59.4,273c-7.24,4.15-7.27,10.94,0,15.16l145.16,87.59A32.69,32.69,0,0,0,231.41,377Z",
    style: {
      fill: "#dedede"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--freepik-shadow-inject-3--inject-2",
    d: "M113.08,360.44c-8.85,4.9-8.85,12.85,0,17.75s23.2,4.9,32.05,0,8.85-12.85,0-17.75S122,355.54,113.08,360.44Z",
    style: {
      fill: "#dedede"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69,259.6s-2.84-19.08-12.11-28.24S43.12,217,46.6,212s20.3,1.53,25.84,18c6.42,19.05,3.42,29.66,3.42,29.66Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69,259.6s-2.84-19.08-12.11-28.24S43.12,217,46.6,212s20.3,1.53,25.84,18c6.42,19.05,3.42,29.66,3.42,29.66Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.68,258.21a.5.5,0,0,1-.5-.46c-2.56-33-21.35-43.4-21.54-43.5a.5.5,0,1,1,.47-.88c.19.1,19.46,10.69,22.07,44.3a.5.5,0,0,1-.46.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.22,234.51a7.8,7.8,0,0,0-3.9,1.23,4.12,4.12,0,0,0-2.18,3.64c.22,3.38,6.32,6.16,6.32,9s-3.65,5.94-2.4,9.76,9.54,3.71,12.1,6.27,1.8,11.12,7,13.35,12.37-3.7,15.15-6.21,5.24-9.49,4.31-13.3-8-4.85-9.6-7.36-.32-10.25-4.74-12-7.63.38-11.39-1.59C49.53,235.53,46.89,234.29,42.22,234.51Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.06,273.73a.51.51,0,0,1-.5-.5c-.21-28.57-26.81-34.67-27.08-34.73a.49.49,0,0,1-.38-.59.51.51,0,0,1,.59-.39c.28.06,27.66,6.32,27.87,35.71a.49.49,0,0,1-.49.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.68,254.59a.49.49,0,0,1-.44-.26.49.49,0,0,1,.2-.67c.35-.19,8.65-4.6,17.94-1.18a.5.5,0,0,1,.3.64.51.51,0,0,1-.64.3c-8.87-3.27-17,1.07-17.12,1.11A.43.43,0,0,1,45.68,254.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.2,329.88s2.84-19.08,12.1-28.24,13.74-14.39,10.25-19.41-20.29,1.52-25.84,18c-6.41,19-3.41,29.66-3.41,29.66Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.2,329.88s2.84-19.08,12.1-28.24,13.74-14.39,10.25-19.41-20.29,1.52-25.84,18c-6.41,19-3.41,29.66-3.41,29.66Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.48,328.49h0A.51.51,0,0,1,415,328c2.6-33.61,21.87-44.2,22.07-44.31a.5.5,0,0,1,.67.21.51.51,0,0,1-.2.68c-.19.1-19,10.47-21.55,43.5A.49.49,0,0,1,415.48,328.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.93,304.79a7.76,7.76,0,0,1,3.91,1.22,4.13,4.13,0,0,1,2.18,3.64c-.22,3.38-6.32,6.16-6.32,9s3.65,5.94,2.39,9.76-9.54,3.7-12.1,6.26-1.8,11.13-7,13.36-12.38-3.71-15.16-6.21-5.23-9.49-4.3-13.31,8-4.85,9.59-7.36.33-10.24,4.74-12,7.64.38,11.4-1.58C439.63,305.81,442.27,304.57,446.93,304.79Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.09,344h0a.51.51,0,0,1-.5-.51c.22-29.39,27.6-35.64,27.87-35.7a.51.51,0,0,1,.6.38.52.52,0,0,1-.39.6c-.27.06-26.87,6.15-27.08,34.73A.5.5,0,0,1,420.09,344Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.48,324.87a.53.53,0,0,1-.24-.06c-.08,0-8.27-4.38-17.12-1.12a.49.49,0,0,1-.64-.29.51.51,0,0,1,.3-.65c9.28-3.42,17.59,1,17.94,1.18a.51.51,0,0,1,.2.68A.49.49,0,0,1,443.48,324.87Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Typewriter--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--freepik--Typewriter--inject-3--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "63.67 231.08 206.89 148.46 206.89 230.9 98.11 293.67 67.68 271.91 63.67 231.08",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.67 231.08 206.89 148.46 206.89 230.9 98.11 293.67 67.68 271.91 63.67 231.08",
    style: {
      fill: "#263238",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.47,142.24a19.5,19.5,0,0,0,8.46,15.49,6,6,0,0,0,6.06.76l13-7.09a6.07,6.07,0,0,0,2.67-5.58,19.36,19.36,0,0,0-8.46-15.49,6,6,0,0,0-6.21-.73l-13,7.06A6.08,6.08,0,0,0,217.47,142.24Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.62,129.33h0a10.18,10.18,0,0,1,10.52,1.15,32.41,32.41,0,0,1,14,25.74,10.12,10.12,0,0,1-4.66,9.45h0L96.74,241.9,76.38,205.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.87,232.75a32.5,32.5,0,0,0-14-25.64c-8-4.88-14.64-1.25-14.88,8.09A32.42,32.42,0,0,0,86.11,241C94.08,245.72,100.87,242.08,100.87,232.75Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.83,222.26A16.51,16.51,0,0,0,83,235.36a5.15,5.15,0,0,0,5.22.63l3.39-1.85a5.19,5.19,0,0,0,2.24-4.7,16.54,16.54,0,0,0-7.15-13.12,5.16,5.16,0,0,0-5.24-.61l-3.37,1.82A5.29,5.29,0,0,0,75.83,222.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 83.15,
    cy: 226.8,
    rx: 6.09,
    ry: 10.55,
    transform: "matrix(0.88, -0.48, 0.48, 0.88, -98.45, 67.51)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.71,133.66,90.32,198.26c-7.25-9.49-14.43-17.89-21.22-25.19l116.15-67A341.38,341.38,0,0,1,208.71,133.66Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.71,133.66a10.24,10.24,0,0,1,10.34,1.28,32.28,32.28,0,0,1,14,25.73,10.49,10.49,0,0,1-4.15,9.09L110.54,234.39a10.58,10.58,0,0,0,4.15-9.1,32.31,32.31,0,0,0-14-25.73,10.29,10.29,0,0,0-10.33-1.3Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.87,152.55a26,26,0,0,1,1.21,8.12,10.49,10.49,0,0,1-4.15,9.09L110.54,234.39a10.58,10.58,0,0,0,4.15-9.1,26,26,0,0,0-1.24-8.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "215.68 129.84 215.74 127 76.47 202.98 76.38 205.83 215.68 129.84",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.74,207.41A955.91,955.91,0,0,0,359.81,289.7a2.46,2.46,0,0,0,3.88-2.3l.18-7.4a11.49,11.49,0,0,0-3-7.24l-34.28-34.65a20.25,20.25,0,0,1-4.28-7l-10.21-31.92a12.91,12.91,0,0,0-4.88-6.24L253.6,160.13c-2-1.22-3.67-.31-3.73,2l-.54,23.27c0,2.34-1.73,3.25-3.73,2l-19.86-12.12c-2-1.21-3.66-.3-3.72,2l-.55,23.25A9.1,9.1,0,0,0,224.74,207.41Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "229.08 169.7 110.69 234.29 144.54 254.97 262.94 190.38 229.08 169.7",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "229.08 169.7 110.69 234.29 144.54 254.97 262.94 190.38 229.08 169.7",
    style: {
      fill: "#263238",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.2,181.1c-.46,18.55-14,40.77-30.32,49.65s-29.09,1-28.67-17.49Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.59,188a36.87,36.87,0,0,1-17.34,28.37c-9.31,5.06-16.64.61-16.37-10Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.77,257.51l-.58,23.28a9.1,9.1,0,0,0,3.28,6.76,953.88,953.88,0,0,0,135.09,82.32l.52.25a9.77,9.77,0,0,0,7.06,0c54-25.89,97-48.9,138.88-75.78a9.11,9.11,0,0,0,3.67-6.55l.18-7.39a11.6,11.6,0,0,0-2.58-6.91l-.3-.31-34.31-34.7a20.45,20.45,0,0,1-4.24-7l-10.22-31.95a12.12,12.12,0,0,0-2.06-3.61,13.41,13.41,0,0,0-2.21-2.18,6.14,6.14,0,0,0-.61-.43L253.6,160.52a8.1,8.1,0,0,0-7.33-.18l-48.41,26.34a2.23,2.23,0,0,0-1.39,2.85,2.21,2.21,0,0,0,1.39,1.39l6.33,3.85a8.15,8.15,0,0,0,7.34.18L232,183.8a8.06,8.06,0,0,1,7.3.18l6.34,3.85a2.24,2.24,0,0,1,0,4.24l-83.23,45.35a8.18,8.18,0,0,1-7.31-.19l-6.33-3.88c-2-1.21-1.94-3,0-4.21L169.16,218a2.22,2.22,0,0,0,0-4.22l-6.34-3.88a8.09,8.09,0,0,0-7.3,0l-48.29,26.34a2.35,2.35,0,0,0-.67.46,8.32,8.32,0,0,0-3,5.18v.61L103,265.76c0,2.33-1.73,3.21-3.7,2L79.38,255.63C77.47,254.27,75.8,255.18,75.77,257.51Zm276.67,20.07a1014.77,1014.77,0,0,1-129.73,70.56,6.61,6.61,0,0,1-6.85-1.27l-31-31.28a20.68,20.68,0,0,1-4.25-7.07l-3-9.69a5.28,5.28,0,0,1,2.43-6.07L309.8,222a3.36,3.36,0,0,1,4.62,1.12,3.45,3.45,0,0,1,.38.88L318,234.14a21.62,21.62,0,0,0,4.27,7l30.77,31.06a3.28,3.28,0,0,1,.29,4.62A3.48,3.48,0,0,1,352.44,277.58Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.61,233.39c0-2.34,1.7-3.25,3.7-2l6.34,3.85a8.15,8.15,0,0,1,3.48,6.43l-.18,7.4a8.24,8.24,0,0,0,3.52,6.54l19.88,12.13c2,1.21,3.64.3,3.7-2l.57-23.28c0-2.34,1.73-3.25,3.7-2l53.74,32.79a13.23,13.23,0,0,1,4.91,6.07l10.19,31.94a21.47,21.47,0,0,0,4.27,7l34.31,34.65a11.31,11.31,0,0,1,2.85,7.21l-.18,7.43a2.46,2.46,0,0,1-3.88,2.3C162.91,343.93,104.72,308.77,65,279.24a9,9,0,0,1-3.3-6.75l.66-27.5Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.35,240.45l53.71,32.79a12.94,12.94,0,0,1,4.91,6.07l10.22,31.94a20.9,20.9,0,0,0,4.24,7l34.28,34.65a6.61,6.61,0,0,0,6.85,1.27,1014.94,1014.94,0,0,0,138.85-75.77,3.3,3.3,0,0,0,1.23-4.51,2.9,2.9,0,0,0-.35-.49l-.3-.31-34.31-34.64a20.45,20.45,0,0,1-4.24-7l-10.22-31.95a12.12,12.12,0,0,0-2.06-3.61,13.41,13.41,0,0,0-2.21-2.18,6.14,6.14,0,0,0-.61-.43L253.6,160.52a8.1,8.1,0,0,0-7.33-.18l-48.41,26.34a2.23,2.23,0,0,0-1.39,2.85,2.21,2.21,0,0,0,1.39,1.39l6.33,3.85a8.15,8.15,0,0,0,7.34.18L232,183.8a8.06,8.06,0,0,1,7.3.18l6.34,3.85a2.24,2.24,0,0,1,0,4.24l-83.23,45.35a8.18,8.18,0,0,1-7.31-.19l-6.33-3.88c-2-1.21-1.94-3,0-4.21L169.16,218a2.22,2.22,0,0,0,0-4.22l-6.34-3.88a8.09,8.09,0,0,0-7.3,0l-48.29,26.34a2.35,2.35,0,0,0-.67.46C105.41,237.66,105.59,239.24,107.35,240.45Z",
    style: {
      fill: "#263238",
      opacity: 0.10000000149011612,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.35,240.45l53.71,32.79a12.94,12.94,0,0,1,4.91,6.07l10.22,31.94a20.9,20.9,0,0,0,4.24,7l34.28,34.65a6.61,6.61,0,0,0,6.85,1.27,1014.94,1014.94,0,0,0,138.85-75.77,3.3,3.3,0,0,0,1.23-4.51,2.9,2.9,0,0,0-.35-.49l-.3-.31-34.31-34.64a20.45,20.45,0,0,1-4.24-7l-10.22-31.95a12.12,12.12,0,0,0-2.06-3.61,13.41,13.41,0,0,0-2.21-2.18,6.14,6.14,0,0,0-.61-.43L253.6,160.52a8.1,8.1,0,0,0-7.33-.18l-48.41,26.34a2.23,2.23,0,0,0-1.39,2.85,2.21,2.21,0,0,0,1.39,1.39l6.33,3.85a8.15,8.15,0,0,0,7.34.18L232,183.8a8.06,8.06,0,0,1,7.3.18l6.34,3.85a2.24,2.24,0,0,1,0,4.24l-83.23,45.35a8.18,8.18,0,0,1-7.31-.19l-6.33-3.88c-2-1.21-1.94-3,0-4.21L169.16,218a2.22,2.22,0,0,0,0-4.22l-6.34-3.88a8.09,8.09,0,0,0-7.3,0l-48.29,26.34a2.35,2.35,0,0,0-.67.46C105.41,237.66,105.59,239.24,107.35,240.45Z",
    style: {
      fill: "#263238",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.44,236.08l48.29-26.34a8.15,8.15,0,0,1,7.33,0l6.31,3.88a2.22,2.22,0,0,1,0,4.22L148.94,229a2.21,2.21,0,0,0,0,4.21l6.33,3.88a8.21,8.21,0,0,0,7.34.18l83.11-45.46a2.24,2.24,0,0,0,0-4.24l-6.34-3.85a8.06,8.06,0,0,0-7.3-.19L211.53,195a8.15,8.15,0,0,1-7.34-.18l-6.33-3.88a2.24,2.24,0,0,1-1.39-2.85,2.21,2.21,0,0,1,1.39-1.39l48.5-26.34a8.1,8.1,0,0,1,7.33.18l53.71,32.76a12.14,12.14,0,0,1,2.85,2.64L163.91,275.7a11.81,11.81,0,0,0-2.85-2.61l-53.74-32.64a2.22,2.22,0,0,1,.12-4.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--freepik--Keys--inject-3--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.8,273.43a.32.32,0,0,1,.24-.28l9.52-5.18a.92.92,0,0,1,.88,0l5.76,3.52v4.18a.36.36,0,0,1-.21.27l-9.55,5.21a1.12,1.12,0,0,1-.88,0l-5.76-3.51a.33.33,0,0,1,0-.24Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331,273.15l6.28-3.42L337,281.25a1,1,0,0,1-.42,0l-5.76-3.52a.33.33,0,0,1,0-.24v-4A.44.44,0,0,1,331,273.15Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.71,277.18a1,1,0,0,0,.91,0l9.52-5.21c.27,0,.27-.36,0-.48L341.38,268a.92.92,0,0,0-.88,0L331,273.15c-.27.15-.3.4,0,.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.34,279.15a.32.32,0,0,1,.22-.27l7.6-4.15a1,1,0,0,1,.91,0l5.73,3.51a.27.27,0,0,1,.18.25v4c0,.09,0,.18-.21.27l-7.61,4.15a.92.92,0,0,1-.88,0l-5.75-3.51s-.16,0-.16-.22S320.34,279.24,320.34,279.15Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.56,278.88l6.27-3.42L326.56,287h-.4l-5.76-3.51s-.15,0-.15-.21v-4a.32.32,0,0,1,.2-.39Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.25,282.88a1,1,0,0,0,.88,0l7.61-4.15c.27,0,.3-.36,0-.52L329,274.7a1,1,0,0,0-.91,0l-7.61,4.15c-.27,0-.3.36,0,.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,284.85a.31.31,0,0,1,.21-.27l7.64-4.15a.92.92,0,0,1,.88,0l5.76,3.51a.33.33,0,0,1,.15.25v4c0,.09,0,.18-.21.24l-7.64,4.18a1.12,1.12,0,0,1-.88,0L310,288.94a.25.25,0,0,1,0-.24Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,284.58l6.3-3.43-.3,11.52a.86.86,0,0,1-.39,0L310,288.94a.25.25,0,0,1,0-.24v-4.12Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.77,288.61a1,1,0,0,0,.91,0l7.6-4.15c.25-.15.28-.4,0-.52l-5.75-3.51a1,1,0,0,0-.88,0L310,284.58c-.24.15-.27.39,0,.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.06,314.22a.31.31,0,0,1,.21-.27l51-27.79a1,1,0,0,1,.88,0l5.76,3.51s.18.15,0,.24a29.22,29.22,0,0,0,0,4,.31.31,0,0,1-.21.28l-51,27.79a.92.92,0,0,1-.88,0l-5.75-3.51a.28.28,0,0,1,0-.22Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.27,314l6.3-3.42-.3,11.48a.9.9,0,0,1-.4,0l-5.75-3.51a.28.28,0,0,1,0-.22v-4A.32.32,0,0,1,256.27,314Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,318a1,1,0,0,0,.91,0l50.92-27.79c.27-.15.3-.37,0-.52L308,286.13a1,1,0,0,0-.88,0l-51,27.79c-.25,0-.28.36,0,.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.6,319.92a.31.31,0,0,1,.21-.27l7.61-4.15a.87.87,0,0,1,.88,0l5.76,3.51s.18.15,0,.21a27.69,27.69,0,0,0,0,4,.29.29,0,0,1-.22.28l-7.42,4.15a1,1,0,0,1-.88,0l-5.76-3.52s-.18-.15,0-.24A28.87,28.87,0,0,0,245.6,319.92Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.81,319.65l6.27-3.43-.27,11.52a.65.65,0,0,1-.39,0l-5.76-3.51s-.18-.16,0-.25a29.22,29.22,0,0,0,0-4A.39.39,0,0,1,245.81,319.65Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.51,323.68a1.12,1.12,0,0,0,.88,0l7.61-4.15c.27,0,.3-.4,0-.52l-5.73-3.51a1,1,0,0,0-.91,0l-7.61,4.15c-.27.15-.3.36,0,.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.11,325.65a.35.35,0,0,1,.21-.27l7.64-4.16a1,1,0,0,1,.88,0l5.76,3.52a.3.3,0,0,1,.15.24v4c0,.09,0,.19-.21.28l-7.64,4.15a.92.92,0,0,1-.88,0l-5.76-3.52a.38.38,0,0,1,0-.21S235.11,325.74,235.11,325.65Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.32,325.32l6.31-3.43-.31,11.49a.86.86,0,0,1-.39,0l-5.76-3.52a.38.38,0,0,1,0-.21v-4A.34.34,0,0,1,235.32,325.32Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241,329.38a1,1,0,0,0,.91,0l7.61-4.15c.24-.16.27-.37,0-.52l-5.76-3.52a1,1,0,0,0-.88,0l-7.58,4.13a.26.26,0,0,0-.16.34.25.25,0,0,0,.16.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.65,331.38a.31.31,0,0,1,.22-.27l7.6-4.16a.92.92,0,0,1,.88,0l5.76,3.52s.18.15,0,.21a29.22,29.22,0,0,0,0,4,.27.27,0,0,1-.21.28l-7.61,4.15a1,1,0,0,1-.88,0l-5.76-3.52s-.18-.15,0-.24A27.26,27.26,0,0,0,224.65,331.38Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.87,331.08l6.33-3.43-.27,11.52a.9.9,0,0,1-.4,0l-5.75-3.52s-.19-.15,0-.24a29.22,29.22,0,0,0,0-4C224.78,331.35,224.71,331.17,224.87,331.08Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.56,335.11a1,1,0,0,0,.88,0l7.61-4.16c.27-.15.3-.39,0-.51l-5.73-3.52a1,1,0,0,0-.91,0l-7.6,4.16c-.28.15-.31.36,0,.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.26,338.11a.38.38,0,0,1,.21-.28l9.64-5.18a1,1,0,0,1,.88,0l5.76,3.52a.33.33,0,0,1,0,.24v4c0,.09,0,.18-.22.27l-9.45,5.16a1,1,0,0,1-.88,0l-5.76-3.52a.25.25,0,0,1,0-.24S212.26,338.2,212.26,338.11Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.47,337.83l6.27-3.42-.27,11.52a.86.86,0,0,1-.39,0l-5.76-3.52a.26.26,0,0,1,0-.24v-4A.37.37,0,0,1,212.47,337.83Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.17,341.87a1,1,0,0,0,.88,0l9.54-5.19c.25-.15.28-.36,0-.51l-5.75-3.52a1,1,0,0,0-.88,0l-9.55,5.18c-.24.16-.27.37,0,.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.62,262.3a.31.31,0,0,1,.21-.27l7.61-4.15a1,1,0,0,1,.91,0l5.76,3.51a.32.32,0,0,1,.15.21v4a.31.31,0,0,1-.21.28L331.23,270a1,1,0,0,1-.88,0l-5.76-3.52a.23.23,0,0,1-.15-.24S324.62,262.39,324.62,262.3Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.83,262l6.4-3.4L331,270.15a.65.65,0,0,1-.39,0l-5.76-3.51a.24.24,0,0,1-.15-.25v-4A.47.47,0,0,1,324.83,262Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.53,266.06a1.12,1.12,0,0,0,.88,0l7.64-4.18c.24,0,.27-.37,0-.49l-5.76-3.51a1,1,0,0,0-.91,0L324.77,262c-.27,0-.3.36,0,.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.55,267.24a.44.44,0,0,1,.25-.27l6.06-3.4a1.12,1.12,0,0,1,.88,0l5.76,3.52a.25.25,0,0,1,.15.24v4c0,.09,0,.19-.21.28l-6.07,3.36a1,1,0,0,1-.9,0l-5.76-3.48v-.25C315.71,271,315.55,267.33,315.55,267.24Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.8,267l6.06,3.85v4.24a1,1,0,0,1-.43,0l-5.75-3.48v-4.22A.41.41,0,0,1,315.8,267Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.5,271a1,1,0,0,0,.87,0l6.07-3.36c.27-.16.3-.37,0-.52l-5.76-3.52a1.12,1.12,0,0,0-.88,0l-6.06,3.4c-.28.15-.31.36,0,.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.52,272.18a.36.36,0,0,1,.21-.27l6.07-3.4a1.11,1.11,0,0,1,.91,0l5.75,3.52a.31.31,0,0,1,.16.24v4c0,.1,0,.19-.22.28l-6.06,3.36a.92.92,0,0,1-.88,0l-5.76-3.51s-.15,0-.15-.22S306.52,272.27,306.52,272.18Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.73,271.91l6.07,3.85V280a.68.68,0,0,1-.4,0l-5.76-3.51s-.15,0-.15-.22v-4A.36.36,0,0,1,306.73,271.91Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.43,275.91a.92.92,0,0,0,.88,0l6.06-3.36c.28-.16.31-.4,0-.52l-5.76-3.52a1.09,1.09,0,0,0-.9,0l-6.07,3.4a.27.27,0,0,0-.16.35.22.22,0,0,0,.16.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.49,277.12a.28.28,0,0,1,.21-.27l6.06-3.39a.87.87,0,0,1,.88,0L310.4,277a.21.21,0,0,1,0,.24v3.94a.33.33,0,0,1-.21.28l-6.06,3.39a1,1,0,0,1-.91,0l-5.76-3.51a.28.28,0,0,1,0-.22S297.46,277.18,297.49,277.12Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.7,276.82l6.06,3.85v4.21a1,1,0,0,1-.42,0l-5.76-3.51a.28.28,0,0,1,0-.22v-4A.27.27,0,0,1,297.7,276.82Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.4,280.85a.92.92,0,0,0,.88,0l6.06-3.36c.27-.15.3-.4,0-.52l-5.76-3.51a.87.87,0,0,0-.88,0l-6.06,3.39c-.27,0-.3.36,0,.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.43,282a.31.31,0,0,1,.21-.27l6.06-3.36a1,1,0,0,1,.91,0l5.76,3.51a.37.37,0,0,1,0,.21v4a.45.45,0,0,1-.24.28l-6.07,3.39a1.1,1.1,0,0,1-.87,0l-5.76-3.51a.28.28,0,0,1-.15-.25S288.43,282.12,288.43,282Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.79,281.76l6.06,3.88v4.21a.65.65,0,0,1-.39,0l-5.76-3.51a.24.24,0,0,1-.15-.25v-4A.31.31,0,0,1,288.79,281.76Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.34,285.91a.92.92,0,0,0,.88,0l6.06-3.39c.24,0,.27-.37,0-.49l-5.76-3.51a.92.92,0,0,0-.88,0l-6.06,3.36c-.24.15-.27.4,0,.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.39,287a.31.31,0,0,1,.22-.27l6.06-3.36a1,1,0,0,1,.88,0l5.76,3.51v4.22a.35.35,0,0,1-.22.27L286,294.7a1,1,0,0,1-.91,0l-5.73-3.51a.3.3,0,0,1-.18-.25S279.39,287.06,279.39,287Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.7,286.7l6.06,3.88v4.21a.75.75,0,0,1-.42,0l-5.73-3.51a.28.28,0,0,1-.19-.24v-4A.37.37,0,0,1,279.7,286.7Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.3,290.73a1,1,0,0,0,.88,0l6.07-3.39c.27,0,.3-.37,0-.52l-5.76-3.51a1,1,0,0,0-.88,0l-6.06,3.36c-.28.15-.31.36,0,.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.33,292a.32.32,0,0,1,.21-.28l6.07-3.36a1,1,0,0,1,.87,0l5.76,3.51a.28.28,0,0,1,0,.25v4a.49.49,0,0,1-.24.27l-6.06,3.36a1,1,0,0,1-.88,0l-5.76-3.51a.3.3,0,0,1-.15-.24Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.6,291.64l6.07,3.88v4.21a.68.68,0,0,1-.4,0l-5.76-3.51a.33.33,0,0,1-.15-.24v-4A.44.44,0,0,1,270.6,291.64Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.24,295.67a1,1,0,0,0,.91,0l6.06-3.36c.25,0,.28-.37,0-.52l-5.76-3.51a1,1,0,0,0-.87,0l-6.07,3.36c-.24.15-.27.37,0,.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.3,296.86a.31.31,0,0,1,.21-.28l6.06-3.39a1,1,0,0,1,.88,0l5.76,3.51a.28.28,0,0,1,0,.25v4c0,.09,0,.18-.21.27l-6.06,3.36a.87.87,0,0,1-.88,0l-5.55-3.48v-.21C261.51,300.64,261.3,297,261.3,296.86Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.51,296.58l6.06,3.85v4.25h-.39l-5.67-3.61v-4.18A.34.34,0,0,1,261.51,296.58Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.21,300.61a1,1,0,0,0,.88,0l6.06-3.36c.27,0,.3-.36,0-.52l-5.76-3.51a1,1,0,0,0-.88,0l-6.06,3.39c-.27,0-.3.37,0,.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.24,301.8a.33.33,0,0,1,.21-.28l6.06-3.39a1,1,0,0,1,.88,0l5.76,3.51a.36.36,0,0,1,0,.25v4c0,.09,0,.18-.21.27l-6.07,3.36a.85.85,0,0,1-.87,0L252.24,306a.26.26,0,0,1,0-.21Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.42,301.52l6.06,3.85v4.22a1.27,1.27,0,0,1-.39,0l-5.76-3.52a.26.26,0,0,1,0-.21v-4A.34.34,0,0,1,252.42,301.52Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.15,305.52a1,1,0,0,0,.91,0l6.06-3.36c.24-.15.27-.39,0-.52l-5.76-3.51a1,1,0,0,0-.88,0l-6.06,3.39c-.27,0-.3.37,0,.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.32,306.74a.35.35,0,0,1,.22-.31l6.06-3.36a1,1,0,0,1,.91,0l5.73,3.51s.18.16,0,.25a28.78,28.78,0,0,0,0,3.94.28.28,0,0,1-.21.27l-6.07,3.4a.92.92,0,0,1-.88,0l-5.76-3.52a.26.26,0,0,1,0-.21Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.32,306.43l6.07,3.88v4.22a.9.9,0,0,1-.4,0L243.23,311a.26.26,0,0,1,0-.21v-4C243.23,306.77,243.32,306.52,243.32,306.43Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.11,310.46a.87.87,0,0,0,.88,0l6.07-3.36c.27-.15.3-.39,0-.52l-5.76-3.51a1,1,0,0,0-.91,0l-6.07,3.39c-.27,0-.3.37,0,.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.23,311.65a.51.51,0,0,1,.24-.28l6.07-3.36a.92.92,0,0,1,.88,0l5.75,3.52v4.18a.36.36,0,0,1-.21.27l-6.06,3.4a1.2,1.2,0,0,1-.91,0l-5.76-3.52a.33.33,0,0,1,0-.24Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.38,311.37l6.07,3.88v4.22a1,1,0,0,1-.43,0L234.26,316a.33.33,0,0,1,0-.24v-4A.49.49,0,0,1,234.38,311.37Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.08,315.41a.92.92,0,0,0,.88,0L247,312c.28,0,.31-.36,0-.48L241.26,308a.92.92,0,0,0-.88,0l-6.06,3.36c-.27.16-.3.4,0,.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.14,316.59a.33.33,0,0,1,.21-.28l6.06-3.36a1,1,0,0,1,.91,0l5.76,3.52v4.21a.3.3,0,0,1-.21.27l-6.06,3.37a1,1,0,0,1-.88,0l-5.79-3.52a.24.24,0,0,1-.15-.24S225.14,316.68,225.14,316.59Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.32,316.22l6.06,3.88v4.22a.86.86,0,0,1-.39,0l-5.85-3.52a.24.24,0,0,1-.15-.24v-4C225,316.5,225.14,316.41,225.32,316.22Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,320.35a1.12,1.12,0,0,0,.88,0L238,317c.27,0,.3-.36,0-.51l-5.76-3.52a1,1,0,0,0-.91,0l-6.06,3.36c-.24.16-.27.37,0,.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.16,328a.31.31,0,0,1,.22-.27l18.18-9.85a1,1,0,0,1,.88,0l5.76,3.52a.25.25,0,0,1,0,.24v4c0,.09,0,.18-.21.27l-18.19,9.85a1,1,0,0,1-.88,0l-5.76-3.51s-.18,0,0-.25A27.67,27.67,0,0,0,204.16,328Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.38,327.74l6.06,3.88v4.21a.68.68,0,0,1-.4,0l-5.75-3.51s-.19,0,0-.24a29.19,29.19,0,0,0,0-4C204.29,328,204.22,327.83,204.38,327.74Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210,331.77a1,1,0,0,0,.88,0l18.19-9.85c.27-.15.3-.36,0-.51l-5.76-3.52a1,1,0,0,0-.88,0l-18.19,9.85c-.27.15-.3.37,0,.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.22,254.54a.31.31,0,0,1,.21-.27l11.91-6.49a.92.92,0,0,1,.88,0L331,251.3a.23.23,0,0,1,.15.21v4a.31.31,0,0,1-.21.27L319,262.27a1.12,1.12,0,0,1-.88,0l-5.76-3.52a.33.33,0,0,1,0-.24S312.22,254.63,312.22,254.54Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.43,254.27l6.31-3.43-.31,11.52a.86.86,0,0,1-.39,0l-5.76-3.51a.36.36,0,0,1,0-.25v-4A.48.48,0,0,1,312.43,254.27Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.13,258.3a1,1,0,0,0,.91,0l11.88-6.52c.27,0,.31-.36,0-.48l-5.76-3.52a.92.92,0,0,0-.88,0l-11.91,6.49c-.24.15-.27.39,0,.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.19,259.48a.31.31,0,0,1,.21-.27l6.06-3.36a1,1,0,0,1,.88,0l5.76,3.51a.25.25,0,0,1,0,.24v4c0,.1,0,.19-.21.28l-6.06,3.36a1,1,0,0,1-.88,0l-5.76-3.51a.27.27,0,0,1-.18-.25S303.19,259.57,303.19,259.48Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.4,259.21l6.06,3.88v4.21a.65.65,0,0,1-.39,0l-5.76-3.51s-.18,0,0-.25a29.2,29.2,0,0,0,0-4C303.31,259.48,303.25,259.3,303.4,259.21Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.1,263.24a1.12,1.12,0,0,0,.88,0l6.06-3.39c.27-.16.3-.37,0-.52l-5.76-3.52a1,1,0,0,0-.88,0l-6.06,3.37c-.27.15-.3.36,0,.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.13,264.42a.36.36,0,0,1,.21-.27l6.06-3.39a1.12,1.12,0,0,1,.88,0l5.76,3.51a.3.3,0,0,1,.15.24v4a.54.54,0,0,1-.21.28l-6.07,3.36a.9.9,0,0,1-.87,0l-5.76-3.48v-.25C294.28,268.3,294.13,264.51,294.13,264.42Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.34,264.15,300.4,268v4.24a.86.86,0,0,1-.39,0l-5.76-3.48v-4.22A.34.34,0,0,1,294.34,264.15Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,268.18a1,1,0,0,0,.91,0l6.06-3.36c.24-.15.27-.37,0-.52l-5.76-3.51a1.12,1.12,0,0,0-.88,0l-6.06,3.39c-.25.15-.28.36,0,.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.09,269.36a.31.31,0,0,1,.21-.27l6.07-3.39a1,1,0,0,1,.88,0l5.75,3.51s.19,0,0,.24a29.34,29.34,0,0,0,0,4c0,.09,0,.18-.21.27l-6.06,3.36a.92.92,0,0,1-.88,0l-5.76-3.51v-4.19Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.3,269.09l6.07,3.85v4.21a.68.68,0,0,1-.4,0l-5.76-3.51v-4.19A.31.31,0,0,1,285.3,269.09Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,273.09a.92.92,0,0,0,.88,0l6.06-3.36c.28,0,.31-.4,0-.52l-5.72-3.51a1,1,0,0,0-.91,0l-6.07,3.39c-.27,0-.3.36,0,.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276,274.3a.45.45,0,0,1,.24-.3l6.06-3.36a.92.92,0,0,1,.88,0l5.76,3.51a.29.29,0,0,1,.15.21v4a.32.32,0,0,1-.21.27L282.85,282a1,1,0,0,1-.91,0l-5.76-3.51a.41.41,0,0,1,0-.22S276,274.36,276,274.3Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.27,274l6.06,3.88v4.21a.75.75,0,0,1-.42,0l-5.76-3.51a.37.37,0,0,1,0-.21v-4A.48.48,0,0,1,276.27,274Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.94,278a1,1,0,0,0,.91,0l6.06-3.36c.27,0,.3-.4,0-.52l-5.58-3.39a.9.9,0,0,0-.87,0l-6.07,3.39c-.27,0-.3.37,0,.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267,279.21a.31.31,0,0,1,.21-.27l6.06-3.36a1,1,0,0,1,.91,0l5.76,3.51v4.19a.31.31,0,0,1-.21.27l-6.06,3.39a1,1,0,0,1-.88,0L267,283.43a.21.21,0,0,1,0-.24S267,279.31,267,279.21Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.21,278.94l6.06,3.88V287a.65.65,0,0,1-.39,0l-5.76-3.51a.25.25,0,0,1,0-.24v-4C267.12,279.21,267.09,279,267.21,278.94Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.91,282.88a.92.92,0,0,0,.88,0l6.06-3.39c.27,0,.3-.37,0-.49l-5.76-3.51a1,1,0,0,0-.91,0l-6.06,3.36c-.24.15-.27.39,0,.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258,284.16a.32.32,0,0,1,.22-.28l6.06-3.36a1,1,0,0,1,.88,0l5.76,3.51a.24.24,0,0,1,.15.25v4a.36.36,0,0,1-.21.27L264.54,292a1.11,1.11,0,0,1-.91,0l-5.76-3.52a.33.33,0,0,1,0-.24S257.93,284.25,258,284.16Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.18,283.88l6.06,3.88V292a1,1,0,0,1-.43,0l-5.75-3.52a.25.25,0,0,1,0-.24v-4C258.06,284.16,258,284,258.18,283.88Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.88,287.91a1,1,0,0,0,.87,0l6.07-3.39c.27,0,.3-.36,0-.52l-5.76-3.51a1,1,0,0,0-.88,0l-6.06,3.36c-.28,0-.31.37,0,.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.9,289.1a.36.36,0,0,1,.21-.28l6.07-3.36a1,1,0,0,1,.91,0l5.75,3.51a.28.28,0,0,1,0,.25v4a.46.46,0,0,1-.24.27l-6.06,3.36a.87.87,0,0,1-.88,0l-5.76-3.48V289.1Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.11,288.94l6.07,3.85V297a.55.55,0,0,1-.4,0L249,293.55v-4.21A.39.39,0,0,1,249.11,288.94Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.81,292.85a1,1,0,0,0,.88,0l6.06-3.36c.25,0,.28-.36,0-.52L256,285.46a1,1,0,0,0-.87,0l-6.07,3.36c-.24,0-.27.37,0,.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.87,294a.31.31,0,0,1,.21-.28l6.06-3.39a1,1,0,0,1,.88,0l5.76,3.51a.23.23,0,0,1,0,.25v4c0,.09,0,.18-.21.27l-6.06,3.37a.92.92,0,0,1-.88,0l-5.76-3.52a.19.19,0,0,1-.18-.21C239.69,297.79,239.87,294.13,239.87,294Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.08,293.76l6.06,3.85v4.22a.86.86,0,0,1-.39,0L240,298.31a.19.19,0,0,1-.18-.21v-4a.3.3,0,0,1,.23-.36Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.78,297.76a.87.87,0,0,0,.88,0l6.06-3.36c.27-.15.3-.36,0-.52L247,290.37a1.12,1.12,0,0,0-.88,0L240,293.76c-.27,0-.3.37,0,.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.81,299a.33.33,0,0,1,.21-.28l6.06-3.39a.92.92,0,0,1,.88,0l5.76,3.52a.33.33,0,0,1,0,.24V303a.39.39,0,0,1-.21.27l-6.07,3.4a.9.9,0,0,1-.87,0l-5.76-3.52a.26.26,0,0,1,0-.21Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,298.7l6.06,3.85v4.22a.86.86,0,0,1-.39,0l-5.76-3.52a.26.26,0,0,1,0-.21v-4A.34.34,0,0,1,231,298.7Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.72,302.71a1,1,0,0,0,.91,0l6.06-3.37c.24-.15.27-.39,0-.51l-5.76-3.52a.92.92,0,0,0-.88,0L231,298.7c-.24,0-.27.37,0,.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.77,303.89a.33.33,0,0,1,.22-.28l6.06-3.36a.92.92,0,0,1,.88,0l5.76,3.52s.18.15,0,.21a27.69,27.69,0,0,0,0,4,.3.3,0,0,1-.22.27l-6.06,3.4a1.12,1.12,0,0,1-.88,0l-5.76-3.52a.26.26,0,0,1,0-.24Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.11,303.61l6.06,3.88v4.22a.86.86,0,0,1-.39,0L222,308.19a.21.21,0,0,1,0-.24v-4C222,303.89,221.83,303.71,222.11,303.61Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.68,307.65a.92.92,0,0,0,.88,0l6.07-3.4c.27,0,.3-.36,0-.48l-5.73-3.52a1,1,0,0,0-.91,0l-6.06,3.36c-.28,0-.31.4,0,.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.71,308.83a.51.51,0,0,1,.24-.28l6.07-3.36a1,1,0,0,1,.88,0l5.75,3.52s.16.15.16.24v4a.35.35,0,0,1-.22.27l-6.06,3.37a1,1,0,0,1-.88,0l-5.88-3.37a.33.33,0,0,1,0-.24S212.71,308.92,212.71,308.83Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,308.55l6.07,3.88v4.22a1,1,0,0,1-.43,0l-5.88-3.46a.33.33,0,0,1,0-.24v-4A.48.48,0,0,1,213,308.55Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.62,312.59a1.11,1.11,0,0,0,.91,0l6.06-3.4c.28,0,.31-.36,0-.51l-5.76-3.52a1,1,0,0,0-.87,0l-6.07,3.36c-.27.16-.3.37,0,.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.83,312.92a.31.31,0,0,1,.21-.27l7.15-3.91a.92.92,0,0,1,.88,0l7.4,4.45a1,1,0,0,0,.91,0l5.6-3a1,1,0,0,1,.88,0l5.76,3.52a.25.25,0,0,1,.18.24v4c0,.09,0,.18-.21.27l-13.79,7.52a1,1,0,0,1-.91,0l-14-8.55a.26.26,0,0,1,0-.21S187.83,313,187.83,312.92Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188,312.65l14.37,8.64v4.45a1,1,0,0,1-.43,0l-14-8.55a.26.26,0,0,1,0-.21v-4A.33.33,0,0,1,188,312.65Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.71,313.62,211,310.16a1,1,0,0,0-.88,0l-5.69,3a1,1,0,0,1-.91,0l-7.4-4.51a.92.92,0,0,0-.88,0L188,312.59c-.24,0-.27.36,0,.48l14,8.55a1.2,1.2,0,0,0,.91,0l13.79-7.55C216.92,314,217,313.77,216.71,313.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.49,243.18a.45.45,0,0,1,.24-.31l9.52-5.18a.92.92,0,0,1,.88,0l5.76,3.52a.27.27,0,0,1,.15.21v4a.31.31,0,0,1-.21.27l-9.52,5.21a1,1,0,0,1-.91,0l-5.76-3.51a.33.33,0,0,1,0-.24S306.49,243.24,306.49,243.18Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.73,242.87l6.07,3.88V251a1,1,0,0,1-.43,0l-5.76-3.52a.33.33,0,0,1,0-.24v-3.94A.48.48,0,0,1,306.73,242.87Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.4,246.9a1,1,0,0,0,.91,0l9.52-5.18c.27,0,.27-.39,0-.51l-5.76-3.52a.92.92,0,0,0-.88,0l-9.52,5.18c-.27,0-.3.4,0,.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.46,248.09a.32.32,0,0,1,.21-.28l6.06-3.36a1,1,0,0,1,.91,0l5.73,3.48s.18.16.18.25v4a.3.3,0,0,1-.21.27l-6.06,3.39a1,1,0,0,1-.88,0l-5.76-3.51a.25.25,0,0,1,0-.24S297.46,248.18,297.46,248.09Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.67,247.81l6.06,3.88v4.22a.86.86,0,0,1-.39,0l-5.76-3.52a.25.25,0,0,1,0-.24v-4C297.58,248.09,297.52,247.9,297.67,247.81Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.37,251.84a1,1,0,0,0,.88,0l6.06-3.39c.27,0,.3-.36,0-.49l-5.76-3.51a1,1,0,0,0-.91,0l-6.06,3.36c-.27,0-.27.4,0,.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.4,253a.51.51,0,0,1,.24-.28l6.06-3.36a1,1,0,0,1,.88,0l5.76,3.52a.25.25,0,0,1,0,.24v4c0,.09,0,.18-.21.27l-6.07,3.37a1.09,1.09,0,0,1-.9,0l-5.76-3.52a.25.25,0,0,1,0-.24Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.79,252.75l6.06,3.88v4.22a1,1,0,0,1-.42,0l-5.76-3.52a.33.33,0,0,1,0-.24v-4A.49.49,0,0,1,288.79,252.75Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.34,256.78a1,1,0,0,0,.88,0l6.06-3.39c.27-.15.3-.36,0-.52l-5.76-3.51a1,1,0,0,0-.88,0l-6.06,3.36c-.27.15-.3.37,0,.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.36,258a.37.37,0,0,1,.22-.28l6.06-3.39a1.2,1.2,0,0,1,.91,0l5.76,3.52a.33.33,0,0,1,0,.24v4c0,.09,0,.18-.22.27L286,265.67a.92.92,0,0,1-.88,0l-5.76-3.49v-.24C279.39,261.7,279.36,258.06,279.36,258Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.7,257.69l6.06,3.85v4.25a.53.53,0,0,1-.39,0l-5.76-3.49v-4.21A.35.35,0,0,1,279.7,257.69Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.27,261.66a1,1,0,0,0,.88,0l6.22-3.36c.24-.15.27-.36,0-.51l-5.76-3.52a1,1,0,0,0-.91,0l-6.06,3.36c-.25.16-.28.37,0,.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.33,262.91a.31.31,0,0,1,.21-.28l6.07-3.39a1,1,0,0,1,.87,0l5.76,3.52a.25.25,0,0,1,.16.24v4c0,.09,0,.18-.22.27l-6.06,3.37a1,1,0,0,1-.91,0l-5.76-3.52v-.21C270.45,266.67,270.3,263,270.33,262.91Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.6,262.63l6.07,3.85v4.22a1,1,0,0,1-.43,0l-5.76-3.52V263A.31.31,0,0,1,270.6,262.63Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.24,266.64a.92.92,0,0,0,.88,0l6.06-3.37c.28-.15.31-.36,0-.51l-5.76-3.52a1,1,0,0,0-.87,0l-6.07,3.39c-.27,0-.3.37,0,.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.27,267.73a.33.33,0,0,1,.24,0l6.21-3.4a.92.92,0,0,1,.88,0l5.76,3.52a.26.26,0,0,1,0,.24V272a.35.35,0,0,1-.24.27l-6.06,3.4a.92.92,0,0,1-.88,0l-5.76-3.52a.26.26,0,0,1,0-.21S261.27,267.91,261.27,267.73Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.51,267.73l6.06,3.85v4.21a.86.86,0,0,1-.39,0l-5.76-3.52a.26.26,0,0,1,0-.21v-4A.32.32,0,0,1,261.51,267.73Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.18,271.58a.92.92,0,0,0,.88,0l6.06-3.37c.24,0,.27-.39,0-.51l-5.76-3.52a.92.92,0,0,0-.88,0l-6,3.55c-.24,0-.27.36,0,.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.24,272.76a.31.31,0,0,1,.21-.27l6.06-3.37a.92.92,0,0,1,.88,0l5.76,3.52s.15,0,.15.21v4a.29.29,0,0,1-.21.27l-6.06,3.4a1.12,1.12,0,0,1-.88,0L252.39,277s-.18-.15,0-.24A29.28,29.28,0,0,0,252.24,272.76Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.42,272.49l6.06,3.88v4.21a.86.86,0,0,1-.39,0l-5.76-3.52s-.18-.15,0-.24a29.22,29.22,0,0,0,0-4C252.33,272.76,252.42,272.58,252.42,272.49Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.15,276.52a.92.92,0,0,0,.88,0l6.06-3.4c.27,0,.3-.36,0-.48l-5.76-3.52a.92.92,0,0,0-.88,0l-6.06,3.37c-.27.15-.31.39,0,.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.32,277.7a.31.31,0,0,1,.22-.27l6.06-3.37a1,1,0,0,1,.88,0l5.76,3.52v4.21a.44.44,0,0,1-.21.27L250,285.43a1,1,0,0,1-.88,0l-5.76-3.52a.33.33,0,0,1,0-.24Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.32,277.43l6.07,3.88v4.21a.9.9,0,0,1-.4,0L243.23,282a.33.33,0,0,1,0-.24v-4C243.23,277.7,243.32,277.52,243.32,277.43Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.08,281.46a1.2,1.2,0,0,0,.91,0l6.07-3.4c.24,0,.27-.36,0-.51L250.3,274a1,1,0,0,0-.88,0l-6.06,3.37c-.25.15-.28.36,0,.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.23,282.64a.29.29,0,0,1,.21-.27l6.07-3.37a1,1,0,0,1,.88,0l5.75,3.52s.19,0,0,.24a29.2,29.2,0,0,0,0,4c0,.09,0,.18-.21.27l-6.06,3.37a1,1,0,0,1-.88,0l-5.76-3.52a.25.25,0,0,1,0-.24Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.23,282.37l6.06,3.88v4.21a.86.86,0,0,1-.39,0l-5.76-3.52a.25.25,0,0,1,0-.24v-4A.29.29,0,0,1,234.23,282.37Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.05,286.4a1,1,0,0,0,.88,0L247,283c.28,0,.31-.36,0-.51L241.26,279a1.11,1.11,0,0,0-.91,0l-6.06,3.37c-.27,0-.3.36,0,.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.14,287.58a.35.35,0,0,1,.24-.27l6.06-3.4a1.12,1.12,0,0,1,.88,0l5.76,3.52a.25.25,0,0,1,0,.24v4c0,.09,0,.18-.21.27l-6.06,3.37a.92.92,0,0,1-.88,0l-5.79-3.52v-4.18Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.32,287.31l6.06,3.85v4.21a1,1,0,0,1-.42,0l-5.82-3.61v-4.18A.34.34,0,0,1,225.32,287.31Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,291.34a1,1,0,0,0,.91,0L238,288c.27,0,.27-.36,0-.51l-5.76-3.52a1.12,1.12,0,0,0-.88,0l-6.06,3.4c-.27,0-.3.36,0,.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.05,292.52a.26.26,0,0,1,.21-.27l6.06-3.4a1,1,0,0,1,.91,0l5.76,3.52a.33.33,0,0,1,0,.24v4c0,.09,0,.18-.21.24l-6.07,3.4a.92.92,0,0,1-.88,0l-5.78-3.52a.2.2,0,0,1,0-.21Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.26,292.25l6.06,3.85v4.21a.65.65,0,0,1-.39,0l-5.88-3.61a.2.2,0,0,1,0-.21v-4A.26.26,0,0,1,216.26,292.25Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.11,296.25a.92.92,0,0,0,.88,0l6.06-3.37c.27-.15.3-.39,0-.51l-5.7-3.43a1,1,0,0,0-.91,0l-6.06,3.4c-.24,0-.27.36,0,.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207,297.43a.44.44,0,0,1,.25-.27l6.06-3.37a.92.92,0,0,1,.88,0l5.76,3.52a.27.27,0,0,1,.15.21v4a.35.35,0,0,1-.22.28l-6.06,3.39a1,1,0,0,1-.91,0L207,301.64a.33.33,0,0,1,0-.24Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.23,297.16l6.06,3.88v4.21a1,1,0,0,1-.43,0L207,301.64a.33.33,0,0,1,0-.24v-4A.5.5,0,0,1,207.23,297.16Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,301.07a.92.92,0,0,0,.88,0l6.07-3.4c.27,0,.3-.36,0-.48l-5.76-3.52a.92.92,0,0,0-.88,0L207.26,297c-.28,0-.31.39,0,.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.86,302.37a.31.31,0,0,1,.21-.27l6.06-3.37a1.11,1.11,0,0,1,.91,0l5.76,3.52v4.21a.3.3,0,0,1-.21.28l-6.06,3.36a1,1,0,0,1-.88,0l-5.76-3.52a.25.25,0,0,1,0-.24S197.86,302.46,197.86,302.37Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.16,302.1l6.06,3.88v4.21a.65.65,0,0,1-.39,0l-5.76-3.51a.28.28,0,0,1,0-.25v-4C198.07,302.37,198,302.19,198.16,302.1Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.92,306.13a1,1,0,0,0,.88,0l6.06-3.39a.28.28,0,0,0,.17-.35.29.29,0,0,0-.17-.17l-5.76-3.49a1,1,0,0,0-.91,0l-6.06,3.37c-.24,0-.27.36,0,.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.73,231.35a.35.35,0,0,1,.22-.27l6.06-3.39a1,1,0,0,1,.91,0l5.76,3.51a.36.36,0,0,1,0,.25v3.94a.28.28,0,0,1-.22.27l-6.06,3.39a.92.92,0,0,1-.88,0l-5.76-3.51a.27.27,0,0,1-.15-.21Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,231l6.06,3.85v4.21a.68.68,0,0,1-.4,0l-5.76-3.51a.27.27,0,0,1-.15-.21v-4A.34.34,0,0,1,302,231Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.64,235a.92.92,0,0,0,.88,0l6.06-3.36c.25-.15.28-.4,0-.52l-5.75-3.51a1,1,0,0,0-.91,0L301.85,231c-.24,0-.27.36,0,.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.7,236.17a.31.31,0,0,1,.21-.27l6.06-3.36a.92.92,0,0,1,.88,0l5.76,3.51a.2.2,0,0,1,0,.21v4a.36.36,0,0,1-.21.27l-6.06,3.39a1.2,1.2,0,0,1-.91,0l-5.7-3.45a.33.33,0,0,1,0-.24S292.67,236.26,292.7,236.17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.91,235.9l6.06,3.88V244a.75.75,0,0,1-.42,0l-5.82-3.54a.33.33,0,0,1,0-.24v-4A.38.38,0,0,1,292.91,235.9Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.61,239.93a.92.92,0,0,0,.88,0l6.06-3.39c.27,0,.31-.37,0-.49l-5.76-3.51a.92.92,0,0,0-.88,0l-6.06,3.36c-.27.15-.3.4,0,.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.64,241.11a.31.31,0,0,1,.21-.27l6.06-3.36a1,1,0,0,1,.91,0l5.76,3.51v4.22a.31.31,0,0,1-.21.27l-6.06,3.36a1,1,0,0,1-.88,0l-5.76-3.51a.21.21,0,0,1,0-.24S283.64,241.21,283.64,241.11Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.85,240.84l6.06,3.88v4.21a.65.65,0,0,1-.39,0l-5.76-3.51a.25.25,0,0,1,0-.24v-4C283.76,241.11,283.73,240.93,283.85,240.84Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.55,244.87a1.12,1.12,0,0,0,.88,0l6.06-3.39a.28.28,0,0,0,.17-.35.29.29,0,0,0-.17-.17l-5.76-3.51a1,1,0,0,0-.91,0l-6.06,3.36c-.24.15-.27.37,0,.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.61,246.05a.3.3,0,0,1,.21-.27l6.06-3.36a1,1,0,0,1,.88,0l5.76,3.51a.28.28,0,0,1,0,.25v4c0,.09,0,.18-.21.27l-6.07,3.36a1,1,0,0,1-.91,0l-5.76-3.51a.33.33,0,0,1,0-.24S274.57,246.15,274.61,246.05Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.82,245.78l6.06,3.88v4.22a1,1,0,0,1-.42,0l-5.76-3.52a.25.25,0,0,1,0-.24v-4A.31.31,0,0,1,274.82,245.78Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.52,249.81a1,1,0,0,0,.87,0l6.07-3.36c.27-.15.3-.36,0-.52l-5.76-3.51a1,1,0,0,0-.88,0l-6.06,3.36c-.28.15-.31.37,0,.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.54,251a.36.36,0,0,1,.21-.28l6.07-3.39a1.2,1.2,0,0,1,.91,0l5.76,3.51a.36.36,0,0,1,0,.25v4c0,.09,0,.18-.22.27l-6.06,3.36a.87.87,0,0,1-.88,0l-5.76-3.51V255C265.57,254.75,265.54,251.09,265.54,251Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.75,250.72l6.07,3.85v4.25h-.4l-5.76-3.52v-4.18A.39.39,0,0,1,265.75,250.72Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.45,254.75a1,1,0,0,0,.88,0l6.22-3.36c.24,0,.27-.36,0-.52l-5.76-3.51a1.2,1.2,0,0,0-.91,0l-6.06,3.39c-.25.15-.28.37,0,.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.51,255.94a.29.29,0,0,1,.21-.28l6.06-3.39a.92.92,0,0,1,.88,0l5.76,3.51a.23.23,0,0,1,0,.25v4c0,.09,0,.18-.21.24l-6.06,3.39a.92.92,0,0,1-.91,0l-5.76-3.51a.26.26,0,0,1,0-.21S256.48,256,256.51,255.94Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.72,255.6l6.06,3.85v4.22a1,1,0,0,1-.42,0l-5.76-3.52a.38.38,0,0,1,0-.21v-4A.28.28,0,0,1,256.72,255.6Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.42,259.66a.87.87,0,0,0,.88,0l6.06-3.36c.27,0,.3-.39,0-.52l-5.76-3.51a.92.92,0,0,0-.88,0l-6.06,3.39c-.27,0-.3.37,0,.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.45,260.85a.32.32,0,0,1,.21-.28l6.06-3.36a1,1,0,0,1,.91,0l5.76,3.52a.26.26,0,0,1,0,.21v4a.28.28,0,0,1-.21.27l-6.06,3.4a1,1,0,0,1-.88,0l-5.76-3.52a.21.21,0,0,1,0-.24S247.45,260.94,247.45,260.85Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.66,260.57l6.06,3.88v4.22a.86.86,0,0,1-.39,0l-5.76-3.52a.26.26,0,0,1,0-.24v-4C247.57,260.85,247.54,260.66,247.66,260.57Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.36,264.7a.92.92,0,0,0,.88,0l6.21-3.4c.24,0,.27-.36,0-.48l-5.76-3.52a1,1,0,0,0-.91,0l-6.06,3.36c-.24.16-.27.4,0,.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.41,265.79a.33.33,0,0,1,.22-.28l6.06-3.36a.92.92,0,0,1,.88,0l5.76,3.49v4.21a.35.35,0,0,1-.22.27l-6.06,3.37a1.11,1.11,0,0,1-.91,0L238.38,270a.33.33,0,0,1,0-.24S238.38,265.88,238.41,265.79Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.63,265.51l6.06,3.88v4.22a1,1,0,0,1-.43,0l-5.75-3.52a.26.26,0,0,1,0-.24v-4C238.51,265.79,238.48,265.61,238.63,265.51Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.33,269.55a1,1,0,0,0,.87,0l6.07-3.4c.27,0,.3-.36,0-.51l-5.76-3.49a.92.92,0,0,0-.88,0l-6.06,3.36c-.28,0-.31.4,0,.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.35,270.76a.31.31,0,0,1,.21-.27l6.07-3.37a1,1,0,0,1,.91,0l5.75,3.52a.25.25,0,0,1,0,.24v4c0,.09,0,.18-.21.27L236,278.49a1,1,0,0,1-.88,0L229.38,275a.25.25,0,0,1,0-.24Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.56,270.45l6.07,3.88v4.22a.9.9,0,0,1-.4,0L229.47,275a.26.26,0,0,1,0-.24v-4C229.47,270.73,229.44,270.55,229.56,270.45Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.26,274.49a1.12,1.12,0,0,0,.88,0l6.22-3.4c.24-.15.27-.36,0-.51l-5.76-3.52a1,1,0,0,0-.88,0l-6.22,3.36c-.24,0-.27.37,0,.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.32,275.67a.29.29,0,0,1,.21-.27l6.06-3.4a1.12,1.12,0,0,1,.88,0l5.76,3.52a.23.23,0,0,1,.15.24v4c0,.09,0,.18-.21.27l-6.06,3.37a1,1,0,0,1-.91,0l-5.85-3.52v-.24C220.35,279.37,220.29,275.76,220.32,275.67Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.53,275.4l6.06,3.84v4.25a1,1,0,0,1-.42,0l-5.82-3.64v-4.21A.28.28,0,0,1,220.53,275.4Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.23,279.43a1,1,0,0,0,.88,0l6.06-3.37c.27-.15.3-.36,0-.51L227.41,272a1.12,1.12,0,0,0-.88,0l-6.06,3.4c-.27.15-.3.36,0,.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.26,280.61a.31.31,0,0,1,.21-.27l6.06-3.4a1,1,0,0,1,.91,0l5.76,3.52a.33.33,0,0,1,0,.24v4c0,.09,0,.18-.21.27l-6.07,3.37a.9.9,0,0,1-.87,0l-5.76-3.52a.2.2,0,0,1,0-.21S211.26,280.7,211.26,280.61Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.47,280.34l6.06,3.85v4.21a.86.86,0,0,1-.39,0l-5.76-3.52a.26.26,0,0,1,0-.21v-4A.32.32,0,0,1,211.47,280.34Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.17,284.34a.92.92,0,0,0,.88,0l6.06-3.37c.24-.15.27-.39,0-.51l-5.55-3.64a1,1,0,0,0-.91,0l-6.06,3.39c-.24,0-.27.37,0,.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.22,285.55a.34.34,0,0,1,.22-.3l6.06-3.37a.92.92,0,0,1,.88,0l5.76,3.52a.26.26,0,0,1,.15.21v4a.35.35,0,0,1-.21.27l-6.07,3.4a1.11,1.11,0,0,1-.91,0l-5.75-3.52a.26.26,0,0,1,0-.24S202.19,285.61,202.22,285.55Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.44,285.25l6.06,3.88v4.21a1,1,0,0,1-.43,0l-5.75-3.52a.25.25,0,0,1,0-.24v-3.94C202.32,285.58,202.28,285.34,202.44,285.25Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.13,289.28a.92.92,0,0,0,.88,0l6.07-3.37c.27-.15.3-.39,0-.51l-5.76-3.52a.92.92,0,0,0-.88,0l-6.06,3.37c-.28.15-.31.39,0,.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.16,290.46a.31.31,0,0,1,.21-.27l6.07-3.37a1,1,0,0,1,.9,0l5.76,3.49v4.21a.28.28,0,0,1-.21.27l-6.06,3.4a1.12,1.12,0,0,1-.88,0l-5.76-3.52a.25.25,0,0,1,0-.24S193.16,290.55,193.16,290.46Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.37,290.19l6.07,3.88v4.21a.9.9,0,0,1-.4,0l-5.76-3.52a.25.25,0,0,1,0-.24v-4C193.28,290.46,193.25,290.28,193.37,290.19Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.07,294.22a1,1,0,0,0,.88,0l6.06-3.4a.26.26,0,0,0,.17-.34.29.29,0,0,0-.17-.17l-5.76-3.49a.92.92,0,0,0-.88,0l-6.06,3.37c-.24.15-.27.39,0,.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.86,297.73a.31.31,0,0,1,.21-.27l10.45-5.7a1,1,0,0,1,.88,0l5.76,3.52a.21.21,0,0,1,0,.24v4c0,.09,0,.18-.21.27l-10.46,5.7a1,1,0,0,1-.88,0L179.86,302s-.19,0,0-.25A29.2,29.2,0,0,0,179.86,297.73Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.07,297.46l6.06,3.88v4.21a.65.65,0,0,1-.39,0L180,302s-.19,0,0-.24a29.19,29.19,0,0,0,0-4C180,297.73,179.92,297.55,180.07,297.46Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.74,301.49a1,1,0,0,0,.87,0l10.46-5.73c.27-.15.3-.36,0-.51l-5.76-3.52a1,1,0,0,0-.88,0L180,297.43c-.28.15-.31.36,0,.52Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M80.77,227a2.27,2.27,0,0,1,2.3-2.24h0c2.64,0,7.49.21,14.22.33,9.09.18,18.19-.58,21.94-3.88s8-2.24,11.67,2.46,4.73,7-.63,6.82L83,229.32A2.3,2.3,0,0,1,80.77,227Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--trash-basket--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--freepik--trash-basket--inject-3--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--freepik--trash-can--inject-3--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.13,365.1c0-6.26,9-11.33,20.16-11.33s20.15,5.07,20.15,11.33v1.49c0,6.26-9,11.33-20.15,11.33s-20.16-5.07-20.16-11.33Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.13,365.1c0-6.26,9-11.33,20.16-11.33s20.15,5.07,20.15,11.33v1.49c0,6.26-9,11.33-20.15,11.33s-20.16-5.07-20.16-11.33Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000238418579,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.13,365.1c0-6.26,9-11.33,20.16-11.33s20.15,5.07,20.15,11.33v1.49c0,6.26-9,11.33-20.15,11.33s-20.16-5.07-20.16-11.33Z",
    style: {
      opacity: 0.10000000149011612,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.13,365.1c0,6.26,9,11.34,20.16,11.34s20.15-5.08,20.15-11.34-9-11.33-20.15-11.33S109.13,358.84,109.13,365.1Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.13,365.1c0,6.26,9,11.34,20.16,11.34s20.15-5.08,20.15-11.34-9-11.33-20.15-11.33S109.13,358.84,109.13,365.1Z",
    style: {
      fill: "#fff",
      opacity: 0.75,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.13,365.1c0,6.26,9,11.34,20.16,11.34s20.15-5.08,20.15-11.34-9-11.33-20.15-11.33S109.13,358.84,109.13,365.1Z",
    style: {
      opacity: 0.05000000074505806,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,332.46a.43.43,0,0,0,.42-.37l2.63-19.22a.44.44,0,0,0-.36-.49h0a.44.44,0,0,0-.49.37L147.57,332a.41.41,0,0,0,.35.48H148Z",
    style: {
      fill: "#263238",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.75,337a.43.43,0,0,0,.43-.39l2.59-24.77a.42.42,0,0,0-.42-.44.43.43,0,0,0-.44.35l-2.58,24.78a.41.41,0,0,0,.38.46h0Z",
    style: {
      fill: "#263238",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.49,339.5a.43.43,0,0,0,.43-.41l1.94-30.36a.42.42,0,0,0-.4-.45.4.4,0,0,0-.45.35s0,0,0,.05L138.07,339a.43.43,0,0,0,.4.46Z",
    style: {
      fill: "#263238",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.47,340.76a.42.42,0,0,0,.43-.42h0l.63-32.95a.43.43,0,0,0-.41-.44h0a.4.4,0,0,0-.44.35v.07L132,340.32a.44.44,0,0,0,.42.44Z",
    style: {
      fill: "#263238",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.1,332.46a.44.44,0,0,1-.43-.37l-2.62-19.22a.43.43,0,0,1,.36-.49h0a.44.44,0,0,1,.49.37L110.53,332a.43.43,0,0,1-.36.48h-.07Z",
    style: {
      fill: "#263238",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.29,337a.42.42,0,0,1-.42-.39l-2.6-24.77a.44.44,0,0,1,.43-.44.42.42,0,0,1,.43.35l2.59,24.78a.41.41,0,0,1-.38.46h0Z",
    style: {
      fill: "#263238",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.57,339.5a.43.43,0,0,1-.42-.41l-1.93-30.36a.43.43,0,0,1,.41-.45.4.4,0,0,1,.45.35v.05L120,339a.44.44,0,0,1-.4.47Z",
    style: {
      fill: "#263238",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.62,340.76a.42.42,0,0,1-.42-.42h0l-.63-32.95A.42.42,0,0,1,125,307h0a.39.39,0,0,1,.43.35.17.17,0,0,1,0,.07l.63,32.95a.45.45,0,0,1-.43.44h0Z",
    style: {
      fill: "#263238",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,345.25c-1.1-1.34-2.56-2.61-2.93-4.38-.28-1.35-.23-2.84-1-4a13.19,13.19,0,0,0-2.1-1.85,6.14,6.14,0,0,1-1.35-7.15,3.82,3.82,0,0,0-3.63,1c-1,.87-1.78,2-2.86,2.73-1.47,1-3.31,1.36-5,2s-3.31,2-3.36,3.83c0,1.64,1.24,3.46.26,4.78-1.51,2-5.44.16-5.28,3.81,0,1.4.54,2.1-.89,3.07s-3.5.46-5,1.48a5.55,5.55,0,0,0-1.64,2.35c-.48,1.05-1,2.1-1.34,3.19a14,14,0,0,0-.31,8.85c.41,1.25,1.1,3.08,2.42,3.49,1.78.57,3.45,0,5.07,1.33.64.53,1.13,1.25,1.76,1.8a6.54,6.54,0,0,0,4.25,1.4c1.22,0,2.4-.46,3.6-.47a9.22,9.22,0,0,1,2.37.52c1.77.42,4,.42,5.31-1,.95-1,1.29-2.65,2.54-3.29s2.87.12,4.35.08c2.47-.06,4.3-2.52,4.7-5s-.24-4.9-.55-7.37c-.4-3.25,2-5.66,1.84-8.64A4.63,4.63,0,0,0,148,345.25Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,345.25c-.45-.56-1-1.1-1.44-1.67-.49,1.55-1.56,2.85-2.17,4.36a16.47,16.47,0,0,0-.76,5.74c0,2.09,0,4.19,0,6.34a1.59,1.59,0,0,1-.28,1.08c-.51.55-1.4.14-1.94-.41s-1-1.24-1.75-1.26-1.58,1-2.44.81a1.32,1.32,0,0,1-.7-1.94,6.12,6.12,0,0,1,1.54-1.78,2.34,2.34,0,0,0,.87-2.09c-2.41-.31-4.5,1.53-6.22,3.23-.76.75-1.58,1.81-1.14,2.8.35.73,1.28,1,1.68,1.74a2,2,0,0,1-.73,2.47,5.74,5.74,0,0,1-2.64.84,4.53,4.53,0,0,1-1.94,0,1.62,1.62,0,0,1-1.28-1.3c-.07-.65.61-1.32,1.22-1.09a7.06,7.06,0,0,0-3.73-1.71c-1.39,0-2.9,1.18-2.59,2.54l-5.54-.12c.76-1.1-.14-2.56-1.07-3.5a7.67,7.67,0,0,1-1.57-1.88,2.22,2.22,0,0,1,.07-2.33c.48-.6,1.4-.9,1.52-1.67a1.26,1.26,0,0,0-1.08-1.27,2.29,2.29,0,0,0-.64,0c-.46,1-.92,2-1.28,3a14,14,0,0,0-.31,8.85c.41,1.26,1.1,3.09,2.42,3.5,1.78.57,3.45,0,5.07,1.33.64.53,1.12,1.24,1.76,1.8a6.52,6.52,0,0,0,4.24,1.39c1.23,0,2.41-.45,3.61-.46a8.82,8.82,0,0,1,2.37.52c1.76.42,4,.41,5.31-1,1-1,1.29-2.66,2.54-3.29s2.87.11,4.35.08c2.47-.06,4.3-2.52,4.7-5s-.24-4.9-.55-7.37c-.41-3.26,1.95-5.66,1.84-8.65A4.61,4.61,0,0,0,148,345.25Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.45,352.52a2,2,0,0,1,.31,1.65,4.4,4.4,0,0,0-.24.86.68.68,0,0,0,.4.7,1,1,0,0,0,.7-.19,2.6,2.6,0,0,1,1.86-.39,1.32,1.32,0,0,1,1.07,1.39,2.64,2.64,0,0,0,0-2.61,1.69,1.69,0,0,0-2.34-.53l0,0a1.55,1.55,0,0,0-.92-1.85,2.57,2.57,0,0,0-2,.08A2.55,2.55,0,0,1,120.45,352.52Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.6,346.65c-.23.16-.5.27-.7.44a.77.77,0,0,0-.33.7c.5-.08.93.34,1.21.75a2.78,2.78,0,0,0,1,1.13c.36.18.82.15,1.14.4.48.37.4,1.1.27,1.68l2.34-1.57a1.18,1.18,0,0,0,.38-.32,1,1,0,0,0-.24-1.31,2.29,2.29,0,0,0-1.36-.45,7.07,7.07,0,0,1-1.45-.15.36.36,0,0,1-.28-.21c-.06-.19.17-.33.35-.4l2.26-.86a.35.35,0,0,0,0-.49l0,0a1.07,1.07,0,0,0-.52-.2,33.68,33.68,0,0,0-4.35-.7C129.29,345.69,130.74,345.87,129.6,346.65Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.19,337.24a2.52,2.52,0,0,0-2.9,1.63,3.81,3.81,0,0,1,2.41,1.65l1,1.21a2.94,2.94,0,0,1,.76,1.28c.09.47,0,1,.24,1.36a1.48,1.48,0,0,0,.78.46,2,2,0,0,0,1.87,0,1.39,1.39,0,0,0,.36-1.49,3.92,3.92,0,0,0-.91-1.36,5.66,5.66,0,0,1,3.33.3,1.14,1.14,0,0,0,.81.13.79.79,0,0,0,.39-.53,1.9,1.9,0,0,0-.79-1.93,3.61,3.61,0,0,0-2.09-.59C138.34,339.36,137.24,337.55,135.19,337.24Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.42,366.21l5.25-35.94a.42.42,0,1,0-.84-.11l-5.26,35.91a.43.43,0,0,0,.35.49H148a.43.43,0,0,0,.42-.37",
    style: {
      fill: "#263238",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.75,371.06a.43.43,0,0,0,.43-.39l3.75-35.93a.43.43,0,1,0-.85-.08l-3.75,35.92a.43.43,0,0,0,.38.48Z",
    style: {
      fill: "#263238",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.49,373.6a.42.42,0,0,0,.43-.39l2.26-35.94a.43.43,0,0,0-.41-.45.41.41,0,0,0-.45.37v0l-2.25,35.93a.42.42,0,0,0,.38.45h0Z",
    style: {
      fill: "#263238",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.47,374.87a.42.42,0,0,0,.43-.42l.76-35.93a.44.44,0,0,0-.42-.44.39.39,0,0,0-.44.35.08.08,0,0,0,0,.07l-.79,36a.45.45,0,0,0,.42.44Z",
    style: {
      fill: "#263238",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.12,374.87h0a.43.43,0,0,0,.42-.43h0l-.75-35.93a.44.44,0,0,0-.43-.42h0a.44.44,0,0,0-.43.44l.76,35.94A.43.43,0,0,0,126.12,374.87Z",
    style: {
      fill: "#263238",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.07,373.6h0a.43.43,0,0,0,.41-.45l-2.26-35.93a.4.4,0,0,0-.4-.4h-.06a.42.42,0,0,0-.4.44h0l2.26,35.94a.41.41,0,0,0,.45.39Z",
    style: {
      fill: "#263238",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.81,371.06h0a.44.44,0,0,0,.39-.48l-3.74-35.92a.42.42,0,0,0-.45-.39h0a.44.44,0,0,0-.39.47h0l3.75,35.93A.43.43,0,0,0,114.81,371.06Z",
    style: {
      fill: "#263238",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.57,366.58h.06a.43.43,0,0,0,.37-.48h0l-5.25-35.93a.45.45,0,0,0-.49-.37.44.44,0,0,0-.36.49l5.25,35.93A.45.45,0,0,0,110.57,366.58Z",
    style: {
      fill: "#263238",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--freepik--Bin--inject-3--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.24,323.23a10.54,10.54,0,0,0,1.7,3.95,19,19,0,0,0,6.38,5.67c11,6.35,28.9,6.35,39.94,0a18.94,18.94,0,0,0,6.37-5.67,10.93,10.93,0,0,0,1.69-3.95h0c1-4.78-1.72-9.79-8.07-13.45-11-6.36-28.92-6.36-39.94,0C103,313.46,100.26,318.45,101.24,323.23Zm11.4,7.69c-3.55-2.05-5.73-4.59-6.53-7.24.79-2.85,3-5.59,6.53-7.79,9.19-5.7,24.09-5.7,33.29,0,3.56,2.2,5.73,4.94,6.53,7.8-.81,2.65-3,5.19-6.55,7.23-9.18,5.3-24.08,5.3-33.27,0Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.24,323.23a10.54,10.54,0,0,0,1.7,3.95,19,19,0,0,0,6.38,5.67c11,6.35,28.9,6.35,39.94,0a18.94,18.94,0,0,0,6.37-5.67,10.93,10.93,0,0,0,1.69-3.95h0c1-4.78-1.72-9.79-8.07-13.45-11-6.36-28.92-6.36-39.94,0C103,313.46,100.26,318.45,101.24,323.23Zm11.4,7.69c-3.55-2.05-5.73-4.59-6.53-7.24.79-2.85,3-5.59,6.53-7.79,9.19-5.7,24.09-5.7,33.29,0,3.56,2.2,5.73,4.94,6.53,7.8-.81,2.65-3,5.19-6.55,7.23-9.18,5.3-24.08,5.3-33.27,0Z",
    style: {
      fill: "#fff",
      opacity: 0.75,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.94,327.18a18.72,18.72,0,0,0,6.37,5.66c11,6.37,28.92,6.37,39.95,0a18.59,18.59,0,0,0,6.36-5.66,10.78,10.78,0,0,0,1.7-3.95h0l-1.25,5c-.58,3.46-3.17,6.84-7.77,9.49-10.48,6.07-27.54,6.07-38.05,0-4.54-2.62-7.12-5.95-7.74-9.37l-.06-.44-1.22-4.67A10.8,10.8,0,0,0,102.94,327.18Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.94,327.18a18.72,18.72,0,0,0,6.37,5.66c11,6.37,28.92,6.37,39.95,0a18.59,18.59,0,0,0,6.36-5.66,10.78,10.78,0,0,0,1.7-3.95h0l-1.25,5c-.58,3.46-3.17,6.84-7.77,9.49-10.48,6.07-27.54,6.07-38.05,0-4.54-2.62-7.12-5.95-7.74-9.37l-.06-.44-1.22-4.67A10.8,10.8,0,0,0,102.94,327.18Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000238418579,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.9,322.72a8.24,8.24,0,0,0,.24,1c.79-2.85,3-5.59,6.53-7.79,9.18-5.7,24.09-5.7,33.28,0,3.56,2.21,5.74,4.94,6.54,7.8a8.52,8.52,0,0,0,.23-1c.7-3.92-1.57-8-6.78-11-9.18-5.31-24.09-5.31-33.27,0C107.44,314.72,105.21,318.77,105.9,322.72Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.9,322.72a8.24,8.24,0,0,0,.24,1c.79-2.85,3-5.59,6.53-7.79,9.18-5.7,24.09-5.7,33.28,0,3.56,2.21,5.74,4.94,6.54,7.8a8.52,8.52,0,0,0,.23-1c.7-3.92-1.57-8-6.78-11-9.18-5.31-24.09-5.31-33.27,0C107.44,314.72,105.21,318.77,105.9,322.72Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000238418579,
      isolation: "isolate"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413.83,348.19a2.61,2.61,0,0,0-1.75,2,20.1,20.1,0,0,1-2.84,5.62c-1.1,1.54-6,5.08-6.73,7.43s1.64,3.59,4.83,3.59,7.53-1.7,8.63-3.69,1.35-4.42,3.24-5.9,2-2,2.29-3.23-.19-4.72-1.09-5.25S413.83,348.19,413.83,348.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.34,338.16a7,7,0,0,0-2.39,1.65c-1.59,1.45-9.62,5.19-13.81,6.53,0,0-1.05.55-1.05,1.35s2.15,3.49,7,3.24,6.58-2.19,10.62-2.74,7.18-.7,8.08-1.85.1-7.41-1.69-8.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.94,343.12s.35,4.39.35,5.32,1.07,1.82,3.36,1.76a6.19,6.19,0,0,0,3.76-1.43l.26-6.28Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.48,332l-.4,5.95c-2.46,2.46-6.82,1.16-6.95.76s-.73-5.85-.73-5.85Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421,291.05l-1.47-52-15.26,4.54V242.4L385.5,241s-5.26,39.76-5.49,44S387,333,387,333s4.53,1.86,8.78,0c0,0,2.57-29.86-.66-42.54l7.4-29.36c.64,11.4,1.51,25.41,2.17,30.9.71,5.9,7.93,51.06,7.93,51.06a9.08,9.08,0,0,0,8.43-.35s2.32-23.17,2.32-32.68C423.33,298,421,291.05,421,291.05Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.48,261.11a15.7,15.7,0,0,1-8.34-4.2,11.14,11.14,0,0,0,5,5.52l-3.34,25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.74,232c-1.79,1.05-7.71,4.38-8.56,3.3a34.53,34.53,0,0,1-1.93-3.61c-2-4.15-4.85-10.29-4.85-10.29l8.48-6,5.21,11.53s1.43,3.31,1.61,4.14A2.57,2.57,0,0,1,438.74,232Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.56,213.14l-2.67,5.78s-18.5-4.55-20.56-6.31-1.66-4.91-1.14-5.91,1.49-2.77.26-2.9-3.47,2.48-3.75,4.52c0,0-.17.24-.78-.07-.8-.4-3.22-2.78-4.85-2.85s-1.68,1.78-1.9,2.46-.88.63-1,1.47.15,1.6-.24,2.14-.77.35-.77,1.21a11.53,11.53,0,0,0,0,2.56c.2.88,3.38,2.72,5.28,3.38s4.65.92,6.6,1.58,23.63,10.6,26.43,10.87,8.38-12.76,8.38-12.76Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351,208.32a1.43,1.43,0,0,1,.22,1.57,1.55,1.55,0,0,1-1.56.62,1.3,1.3,0,0,1,.57,1.47,1.19,1.19,0,0,1-1.38.81,1.75,1.75,0,0,1,.26,1.66c-.39.79-1.47.6-1.47.6a1.45,1.45,0,0,1,.35,1c-.11.5-.7.55-.7.55s.8.22,1.16-.17a.68.68,0,0,0,.14-.82s1,0,1.29-.56a2,2,0,0,0,0-1.83,1.72,1.72,0,0,0,.79-.29,3.15,3.15,0,0,0,2.12,2.17,5.93,5.93,0,0,1-1.29-4.07C351.64,209.78,352.14,208.93,351,208.32Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.57,192.44a17.54,17.54,0,0,0-8.46,10.08c-2.12,6.5-3.66,11.88-3.66,11.88a27.54,27.54,0,0,0,9.51,3.51Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.57,192.44a17.54,17.54,0,0,0-8.46,10.08c-2.12,6.5-3.66,11.88-3.66,11.88a27.54,27.54,0,0,0,9.51,3.51Z",
    style: {
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.17,190.41a12.58,12.58,0,0,0-10,5.35,9,9,0,0,0-1.43,3.77C385.24,209.69,385.5,241,385.5,241a38.29,38.29,0,0,0,19.65,4.3c11.87-.9,14.36-6.23,14.36-6.23V217.17l3.29,5.53s8.68-3.63,11.17-6.21c0,0-5.09-13.46-9.47-18.05s-15-7.43-15-7.43Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.17,190.41a12.58,12.58,0,0,0-10,5.35,9,9,0,0,0-1.43,3.77C385.24,209.69,385.5,241,385.5,241a38.29,38.29,0,0,0,19.65,4.3c11.87-.9,14.36-6.23,14.36-6.23V217.17l3.29,5.53s8.68-3.63,11.17-6.21c0,0-5.09-13.46-9.47-18.05s-15-7.43-15-7.43Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "419.51 217.16 416 210.12 419.51 219.12 419.51 217.16",
    style: {
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.35,240.45a2.81,2.81,0,0,0-2.65,1.89l-.52,1.48a3.24,3.24,0,0,0-2.1,5.91l-.69,1.93a2.75,2.75,0,0,0,1.69,3.54l5.18-14.59A2.61,2.61,0,0,0,407.35,240.45Zm-3,6.71c-.3.89-1.06,1.45-1.69,1.24a1.6,1.6,0,0,1-.73-2,1.64,1.64,0,0,1,1.82-1.22A1.53,1.53,0,0,1,404.32,247.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "444.27 247.01 434.53 274.36 399.28 261.82 409.02 234.46 444.27 247.01",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.94,241.51a2.83,2.83,0,0,0-2.66,1.89l-.51,1.48a3.24,3.24,0,0,0-2.1,5.91l-.69,1.93a2.74,2.74,0,0,0,1.69,3.53l5.18-14.59A2.89,2.89,0,0,0,406.94,241.51Zm-3,6.7c-.3.9-1.06,1.46-1.69,1.24a1.58,1.58,0,0,1-.73-2,1.64,1.64,0,0,1,1.82-1.22A1.53,1.53,0,0,1,403.91,248.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.16,159.57a5.56,5.56,0,0,1-4.09.08.39.39,0,0,0-.55.44c.38,1.54,1.63,4.73,5.57,4.58C394.28,164.47,388.16,159.57,388.16,159.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.54,191s-1,4.81-7.08,6.33c-5.74,1.44-6.79-1.94-6.24-3.69a9.27,9.27,0,0,1,1.95-3.24V186l4.52-2.51,6.85-5.47S409,189,409.54,191Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.54,254.7c-.4.31-1.22.65-2.73,1.56s-5.06,3.86-4.85,4.33a1.44,1.44,0,0,0,2.09.66c1.24-.56,1.7-1.11,2-1s-1.16,2.08-2,3.11-3,3.28-2.52,4.4,4.48,2.36,7.17,1,3.95-4.33,4.54-5.87,2.45-6.08,3.34-8c.55-1.19,5.57-10.77,8.37-17.08a19.25,19.25,0,0,0,1.81-5.8l-10.16-1.15S421.94,254.39,421.54,254.7Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.09,181.57s-1.78,4.87-8.92,6.58V186l4.52-2.51Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.32,172.91a2.5,2.5,0,0,0-1.83-2.36,3.29,3.29,0,0,0-3.52.84c.08-.53.15-1,.2-1.54.4-4.39.13-9.11-4.19-11.24s-16.76-3.12-18.42,2.8A37,37,0,0,0,387.3,175c.8,7.11,3.85,11.23,6.18,12a11.73,11.73,0,0,0,5.9-.31,15,15,0,0,0,8.79-6.64h0C413.85,182,416.52,175,416.32,172.91Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.63,159.63a6.06,6.06,0,0,1,2.79-2,3.14,3.14,0,0,0-3.29.19,3.68,3.68,0,0,0-1.23-3.33c-2.46-2.32-12-.6-17.65-1.66a22.66,22.66,0,0,1-7.87-2.82.65.65,0,0,0-1,.51c-.14,2.72,0,9.35,4.58,11.29,5.78,2.46,14.85,1.51,15.31,1.51s.18,4.3,1.84,5.43,2,.7,2.4,2.23a16.22,16.22,0,0,1,.4,3.46s1.86-4,5.58-3.89C414.49,170.55,418.08,160.63,412.63,159.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.59,171.57a1.15,1.15,0,1,1-1.15-1.16A1.15,1.15,0,0,1,392.59,171.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.78,171.86a1.16,1.16,0,1,1-1.15-1.15A1.15,1.15,0,0,1,401.78,171.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.56,166.69a1.69,1.69,0,0,0-2-.2,1.53,1.53,0,0,0-.49,1.73A11.7,11.7,0,0,1,391.56,166.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.63,167.42a1.8,1.8,0,0,1,2-.21,1.43,1.43,0,0,1,.49,1.74S401.55,167.91,400.63,167.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.25 170.96 392.25 176.95 395.96 178.06 396.25 170.96",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.23,180.12a8.72,8.72,0,0,1-2.25.8c-1.24.24.26,1.59,1.47,1.12S399.23,180.12,399.23,180.12Z",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.39,414.76a3.32,3.32,0,0,1,.44,1.63,37.66,37.66,0,0,1,0,5.21c-.16.79-1.9,2-4,1.72s-3.62-1.88-4.68-3.5-5.71-7.2-6.56-8.55-2.17-4.92-.52-6.39c1.39-1.24,6.57,1.58,7.95,3.15S334.39,414.76,334.39,414.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.31,431.16a7.6,7.6,0,0,1,1,2.6c.34,1.5.87,5.09.59,6.17-.13.52-2,1.84-3.83,1.94-1.09.07-2.4.11-3.45.14a5.37,5.37,0,0,0-2.26.58,62.54,62.54,0,0,1-5.84,2.65c-3.48,1.32-8.05,1.83-10.25,1.38a10.77,10.77,0,0,1-5.82-3.22,2,2,0,0,1,.1-2.26c2.69-2.24,7.15-3.34,9.91-4.49a70.83,70.83,0,0,0,10.76-5.81C303.93,430.3,312.31,431.16,312.31,431.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.35,234.6c-.06-2-.06-3.64,0-4.55a9,9,0,0,1,2.24-5.54c5.73-5.75,19.29-3.81,20.42-.62s3.35,20.6-1.56,23.7c.5,2.72,1.34,9.61,1.34,9.61-4,3.6-11.69,2.2-11.69,2.2.25-1.21-.83-5.58-1.43-8-3.4.41-6.71.21-7.67-.51-1.58-1.89-1.67-5.38-1.71-9.54-1.08-.37-2.36-.65-2.69-1.41C294.42,239.49,296.52,236.08,297.35,234.6Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299,250.84c1.2.91,4.27.92,7.67.51a13.75,13.75,0,0,0,1.79-2.31C308.18,249.15,302.44,251.84,299,250.84Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.67,235.73a3.81,3.81,0,0,1,3.43-3.32c3.1-.29,5.07,3.69,3.53,6.62s-5.16,3-5.16,3a39.82,39.82,0,0,0,1.59,5.94c.43,1,1,2.54,2.66,2.76a19.28,19.28,0,0,0,9.28-1.88c4.36-2.12,7.14-7.34,8.57-13.66s.33-11.17-2.48-12.36a5.78,5.78,0,0,1,2.75-1.69,3.09,3.09,0,0,0-4.55.31,7,7,0,0,0-5.11-5.48c-4.6-1.38-10.31-.47-15.08,1.26s-7.81.86-8.4,1.55c-1.08,1.28,0,8.72,6.66,9.61C303.36,228.35,303.72,235.68,305.67,235.73Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.67,235.73a3.81,3.81,0,0,1,3.43-3.32c3.1-.29,5.07,3.69,3.53,6.62s-5.16,3-5.16,3a39.82,39.82,0,0,0,1.59,5.94c.43,1,1,2.54,2.66,2.76a19.28,19.28,0,0,0,9.28-1.88c4.36-2.12,7.14-7.34,8.57-13.66s.33-11.17-2.48-12.36a5.78,5.78,0,0,1,2.75-1.69,3.09,3.09,0,0,0-4.55.31,7,7,0,0,0-5.11-5.48c-4.6-1.38-10.31-.47-15.08,1.26s-7.81.86-8.4,1.55c-1.08,1.28,0,8.72,6.66,9.61C303.36,228.35,303.72,235.68,305.67,235.73Z",
    style: {
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.75,251.11a1.35,1.35,0,0,0-1.94-.71l-2.32,1.32a3.6,3.6,0,0,0-3.84-1.38,3.61,3.61,0,0,0-2.37,5l-2.37,1.38a2,2,0,0,0-.86,2.37l.64,1.51,13.71-7.92Zm-6.61,3.39a2,2,0,0,1-2.5-.11,2.06,2.06,0,0,1,.92-2.58,2.09,2.09,0,0,1,2.69.42C283.63,252.84,283.1,253.94,282.14,254.5Z",
    style: {
      fill: "#4e646d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "267.11 263.23 283.03 306.7 309.24 291.57 293.32 248.1 267.11 263.23",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.14 263.44 284.05 304.17 307.21 290.8 292.3 250.07 269.14 263.44",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.58,266.05a.13.13,0,0,1-.11-.07.13.13,0,0,1,0-.18l19-11a.13.13,0,1,1,.13.23l-19,10.95Z",
    style: {
      fill: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.17,267.64a.13.13,0,0,1-.12-.07.14.14,0,0,1,.05-.18l19-10.95a.13.13,0,0,1,.18.05.13.13,0,0,1-.05.18l-19,10.95Z",
    style: {
      fill: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.75,269.23a.15.15,0,0,1-.12-.07.14.14,0,0,1,.05-.18l19-11a.13.13,0,1,1,.13.23l-19,10.95Z",
    style: {
      fill: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.33,270.82a.15.15,0,0,1-.12-.07.14.14,0,0,1,.05-.18l19-10.95a.12.12,0,0,1,.18.05.13.13,0,0,1,0,.18l-19,10.95Z",
    style: {
      fill: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.91,272.4a.13.13,0,0,1-.11-.06.13.13,0,0,1,0-.18l19-11a.13.13,0,0,1,.14.22l-19,11Z",
    style: {
      fill: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.49,274a.13.13,0,0,1-.11-.06.12.12,0,0,1,.05-.18l19-11a.14.14,0,0,1,.18,0,.14.14,0,0,1-.05.18l-19,11A.1.1,0,0,1,275.49,274Z",
    style: {
      fill: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.07,275.58a.13.13,0,0,1-.11-.06.13.13,0,0,1,.05-.19l19-10.95a.13.13,0,1,1,.13.23l-19,10.95A.08.08,0,0,1,276.07,275.58Z",
    style: {
      fill: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.66,277.17a.13.13,0,0,1-.12-.07.13.13,0,0,1,0-.18l19-10.95a.13.13,0,1,1,.13.23l-19,10.95Z",
    style: {
      fill: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.24,278.76a.15.15,0,0,1-.12-.07.14.14,0,0,1,.05-.18l19-10.95a.13.13,0,0,1,.18.05.13.13,0,0,1-.05.18l-19,10.95Z",
    style: {
      fill: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.82,280.35a.15.15,0,0,1-.12-.07.14.14,0,0,1,.05-.18l19-11a.12.12,0,0,1,.18.05.13.13,0,0,1,0,.18l-19,10.95Z",
    style: {
      fill: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.4,281.93a.11.11,0,0,1-.11-.06.13.13,0,0,1,0-.18l19-10.95a.13.13,0,1,1,.14.22l-19,11Z",
    style: {
      fill: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279,283.52a.13.13,0,0,1-.11-.06.12.12,0,0,1,.05-.18l19-11a.14.14,0,0,1,.18.05.13.13,0,0,1,0,.18l-19,11Z",
    style: {
      fill: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.56,285.11a.13.13,0,0,1-.11-.06.12.12,0,0,1,.05-.18l19-11a.14.14,0,0,1,.18,0,.14.14,0,0,1,0,.18l-19,10.95A.1.1,0,0,1,279.56,285.11Z",
    style: {
      fill: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.14,286.7a.12.12,0,0,1-.11-.07.13.13,0,0,1,.05-.18l19-10.95a.13.13,0,1,1,.13.23l-19,10.95Z",
    style: {
      fill: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.73,288.29a.13.13,0,0,1-.12-.07.14.14,0,0,1,.05-.18l19-11a.13.13,0,1,1,.13.23l-19,10.95Z",
    style: {
      fill: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.31,289.88a.15.15,0,0,1-.12-.07.14.14,0,0,1,.05-.18l19-10.95a.13.13,0,1,1,.13.23l-19,10.95Z",
    style: {
      fill: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.89,291.47a.15.15,0,0,1-.12-.07.14.14,0,0,1,.05-.18l19-11a.13.13,0,0,1,.18,0,.13.13,0,0,1-.05.19l-19,10.95Z",
    style: {
      fill: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.47,293.05a.11.11,0,0,1-.11-.06.13.13,0,0,1,0-.18l19-10.95a.13.13,0,1,1,.14.22l-19,11Z",
    style: {
      fill: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.05,294.64a.13.13,0,0,1-.11-.06.12.12,0,0,1,.05-.18l19-11a.14.14,0,0,1,.18.05.14.14,0,0,1-.05.18l-19,11Z",
    style: {
      fill: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.63,296.23a.13.13,0,0,1-.11-.06.12.12,0,0,1,.05-.18l19-11a.13.13,0,1,1,.13.23l-19,10.95A.08.08,0,0,1,283.63,296.23Z",
    style: {
      fill: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.21,297.82a.13.13,0,0,1-.11-.07.13.13,0,0,1,0-.18l19-10.95a.13.13,0,1,1,.13.23l-19,10.95Z",
    style: {
      fill: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.8,299.41a.15.15,0,0,1-.12-.07.14.14,0,0,1,.05-.18l19-11a.13.13,0,0,1,.18.05.13.13,0,0,1-.05.18l-19,10.95Z",
    style: {
      fill: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.72,251.71a1.34,1.34,0,0,0-1.94-.71l-2.31,1.32a3.6,3.6,0,0,0-6.32.88,3.54,3.54,0,0,0,.1,2.71l-2.36,1.38a2,2,0,0,0-.86,2.37l.63,1.51,13.72-7.92Zm-6.61,3.39a2,2,0,0,1-2.49-.11,2,2,0,0,1,.91-2.58,2.09,2.09,0,0,1,2.69.42C282.61,253.44,282.08,254.54,281.11,255.1Z",
    style: {
      fill: "#263238",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.31,426.05v5.11a6,6,0,0,1-4.59,2.1,4.51,4.51,0,0,1-4.47-2.42,40.87,40.87,0,0,0,.12-4.79Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.39,411.68v3.08s-.46,1.62-3.54,1.71a5.62,5.62,0,0,1-3.78-1.17l-.65-4.52Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.87,278.64s4.39,11.71,3.9,15.62S342,299.56,340,300s-8.55-2.42-8.55-2.42l.8-16.36Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.39,317.34s1.09,48.72,2.5,57.62c1,6.1,7.44,52.38,7.44,52.38a9.7,9.7,0,0,0,9.13-.08s0-1.63.22-4.28,2.24-25.25,2-33.75a40.7,40.7,0,0,0-2.86-14.39l2.87-42,1.33.17s-.07,4.48.49,12.44c0,0,1,16,1.43,19.19.71,5.87,4.64,27.27,5.8,32.95,1,5.08,2.73,14.47,2.73,14.47,2.49,2.47,7.9.52,7.9.52s.27-6.38.55-10.27,1.47-21.38,1-26c-.66-6.4-3.28-12.55-3-14.18,1.36-9.42,1.49-49.51,1.49-49.51Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.71,332.83l1.34.17s-.08,4.76.51,13.22c0,0,.26,4,.58,8.56l2.18-21.54A35,35,0,0,0,329.69,324c-8.84,6.78-15,8.87-15,8.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.62,257.36s3.79,1.61,7.18,8A119.29,119.29,0,0,1,344,280.16a16.3,16.3,0,0,1-10.54,4.75Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.62,257.36s3.79,1.61,7.18,8A119.29,119.29,0,0,1,344,280.16a16.3,16.3,0,0,1-10.54,4.75Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.42,284.52c-.35,8.23-1,32.82-1,32.82s12.8,4.79,23.95,3.14,17-7.85,17-7.85.5-43.49-.3-48.77-4.37-7.79-7.09-8.39-6.83.53-6.83.53a22.33,22.33,0,0,1-11.88,2.73C292.68,262.11,294.73,277.21,294.42,284.52Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.42,286.9v4.68c3.91-4.42,10.31-14.73,10.31-14.73Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.57,288.53s-7.85,10-11.13,11.55-25.75-14.92-28.68-16.21-10-4.26-11.09-5.77a6.43,6.43,0,0,1,1.25-5.77s.08-2.71,1.78-3.16c0,0-5-6.61-4.36-7.54s2.24-.38,3.73,1.14,7.92,9,8.63,9.21,1-2.18,2.15-3.74,3-1.6,2.91-.29-1.11,5-1.08,6.62,1.49,2.86,2.68,3.77,18.37,9.53,18.37,9.53l6.7-7.67Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.49,258.91a22.47,22.47,0,0,0-12.76,5.89c-5.64,5.41-12.41,14.91-12.41,14.91A27,27,0,0,0,293,290.18s13.49-13.68,16.12-20.28A10.51,10.51,0,0,0,307.49,258.91Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.49,258.91a22.47,22.47,0,0,0-12.76,5.89c-5.64,5.41-12.41,14.91-12.41,14.91A27,27,0,0,0,293,290.18s13.49-13.68,16.12-20.28A10.51,10.51,0,0,0,307.49,258.91Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticleEditor);
export default __webpack_public_path__ + "static/media/ArticleEditor.0aedd1397a5759d5e82fdf2e1df32501.svg";
export { ForwardRef as ReactComponent };